import React, { FC, useEffect, useState } from 'react'
import { Card, Flex, Spin, Typography } from 'antd'
import { ModuleAudioExerciseDto } from '../../../../../shared/types/api'
import * as API_COURSES from '../../../../../shared/http/courses'
import AudioPlayer from 'react-h5-audio-player'
import 'react-h5-audio-player/lib/styles.css'


const { Text } = Typography

interface AudioPlayerProps {
    ex: ModuleAudioExerciseDto,
    removeExercise: (exId: number) => void
}

export const AudioPlayerGE: FC<AudioPlayerProps> = ({ ex, removeExercise }) => {

    const [loading, setLoading] = useState<boolean>(false)
    const [url, setUrl] = useState<string | undefined>(undefined)


    useEffect(() => {
        setLoading(true)
        API_COURSES.playAudioExerciseV2(Number(ex.id))
            .then((blob) => {
                const url = URL.createObjectURL(blob)
                setUrl(url)
            })
            .catch((err) => console.error(err))
            .finally(() => {
                setLoading(false)
            })
        return () => {
        }
    }, [])

    const deleteAudio = () => {
        if (ex.id) {
            API_COURSES.deleteTestExercise(ex.id).then(resp => {
                removeExercise(Number(ex.id))
            })
        }
    }

    return (
        <Card style={{ marginTop: 16 }}>
            <Text>{ex.data.title}</Text>
            <Flex align={'center'} gap={16} style={{ marginTop: 16 }}>
                {!loading && url ?
                    <AudioPlayer
                        showJumpControls={false}
                        layout='stacked-reverse'
                        src={url}
                        onPlay={e => console.log('onPlay')}
                        // other props here
                    /> : <Spin />
                }
                {/* <a>Редактировать</a>*/}
                <a onClick={deleteAudio}>Удалить</a>
            </Flex>

        </Card>
    )
}

